import "./style.scss";
import { Title } from "@clipboard-health/ui-react";
import { IonAlert, IonPage } from "@ionic/react";
import { Box, Button, Card, CardContent, Divider, Stack } from "@mui/material";
import { useSession } from "@src/app/store/helperHooks";
import { AppBarHeader, BackButtonLink, PageWithHeader, useToast } from "@src/appV2/lib";
import { Agent } from "@src/lib/interface";
import { useEffect, useState } from "react";

import { getAgreement } from "./api";
import { RouterPath } from "../../routing/constant";

export const OldContractPage = () => {
  const { agent } = useSession();
  const [page, setPage] = useState<string>("<div>Loading...</div>");
  const { showSuccessToast, showErrorToast } = useToast();

  const [showSendEmailAlert, setShowSendEmailAlert] = useState(false);

  const { email } = agent as Agent;

  const emailAgreement = async () => {
    showSuccessToast("The contract has been sent!");
    try {
      await getAgreement(true);
    } catch (error) {
      showErrorToast("There was an error on sending the contract");
    }
  };

  useEffect(() => {
    getAgreement().then((agreement) => setPage(agreement as string));
  }, []);

  return (
    <IonPage>
      <PageWithHeader
        appBarHeader={
          <AppBarHeader
            title="Contract Agreement"
            leftCta={<BackButtonLink defaultBackTo={RouterPath.PROFILE} />}
          />
        }
      >
        <Stack
          sx={{
            height: "100%",
          }}
          spacing={2}
        >
          <Card elevation={4}>
            <CardContent sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
              <Title component="h2" variant="h3">
                See agreement below
              </Title>
              <Divider />
              <Box
                /**
                 * FIXME: This is dangerous since the page content isn't sanitized.
                 * Look into sanitizing the page, or converting to Markdown.
                 */
                dangerouslySetInnerHTML={{ __html: page }}
                sx={{
                  overflowY: "auto",
                  paddingX: 2,
                  paddingY: 1,
                  flex: 1,
                }}
              ></Box>
            </CardContent>
          </Card>
          <Button variant="contained" fullWidth onClick={() => setShowSendEmailAlert(true)}>
            Email Me My Agreement
          </Button>
        </Stack>
      </PageWithHeader>
      <IonAlert
        isOpen={showSendEmailAlert}
        onDidDismiss={() => setShowSendEmailAlert(false)}
        header={"Email Your Agreement?"}
        message={`We'll send an email to ${email}`}
        backdropDismiss={true}
        buttons={[
          {
            text: "Never Mind",
            role: "cancel",
            handler: () => setShowSendEmailAlert(false),
          },
          {
            text: "Yes, send",
            handler: emailAgreement,
          },
        ]}
      />
    </IonPage>
  );
};
